import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const baseResource = `${MERCATELY_API}/bsp/voice`;
const model = abstractModel(baseResource);
const csrfToken = document.querySelector('[name=csrf-token]').content;

model.createCallEvent = async (params) => model.post(params, { path: `${baseResource}/call_events`, csrfToken });

export default model;
